import { SidebarReducerState, SidebarReducerActions, SidebarReducerActionTypes } from "./sidebar-types";

export const sidebarReducer = (state: SidebarReducerState, action: SidebarReducerActions): SidebarReducerState => {
    switch (action.type) {
        case SidebarReducerActionTypes.setObjectDetailsMinimised: {
            return {
                ...state,
                isObjectDetailsMinimised: action.payload,
            };
        }

        case SidebarReducerActionTypes.setTransitionCompleted: {
            return {
                ...state,
                transitionCompleted: action.payload,
            };
        }

        case SidebarReducerActionTypes.setAttributeDataField: {
            return {
                ...state,
                attributeDataField: action.payload,
            };
        }

        case SidebarReducerActionTypes.setShowAttributeModal: {
            return {
                ...state,
                showAttributeModal: action.payload,
            };
        }

        case SidebarReducerActionTypes.setModal: {
            return {
                ...state,
                modal: action.payload,
            };
        }
        default:
            // @ts-expect-error expecting error here because all actions should be handled.
            throw Error(`No case exists for SidebarReducerActionType of ${action.type}`);
    }
};
